function updateUrlWithNewPage(newPage: number): void {
	const searchParams = new URLSearchParams(window.location.search);
	searchParams.set("page", newPage.toString());
	const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
 	window.history.pushState(null, "", newUrl);
}
export default updateUrlWithNewPage;
